import api from './api';

export type HomepageSliderImage = {
  readonly id: string;
  readonly imageUrl: string;
  readonly thumbnailUrl: string | null;
  readonly widthPx: number | null;
  readonly heightPx: number | null;
  readonly altText: string;
  readonly title: string | null;
  readonly caption: string | null;
  readonly linkUrl: string | null;
  readonly sortOrder: number;
};

type HomepageSliderImagesResponse = {
  readonly data: {
    readonly images: ReadonlyArray<HomepageSliderImage>;
  };
};

export const fetchHomepageSliderImages = async (): Promise<ReadonlyArray<HomepageSliderImage>> => {
  const response = await api.get<HomepageSliderImagesResponse>('/homepage/slider-images');
  return response.data.data.images;
};
